import { Suspense } from "react"

import Section from "./Section"
import { sectionHeaderDefaultClasses } from "./SectionHeader"

import { useSale } from "web/hooks/data"

export function SaleWithoutFetch({ sale, ...rest }) {
  return <Section subjectType="sale" data={sale} icon="briefcase" {...rest} />
}

export function SaleWithFetch({ saleId, sale, ...rest }) {
  const fetchedSale = useSale(saleId)
  return <SaleWithoutFetch {...rest} sale={{ ...sale, ...fetchedSale }} />
}

export default function Sale(props) {
  const { sale, saleId } = props

  const hasSale = !!sale
  const saleIsShallow = hasSale && sale.is_shallow

  const fetch = !hasSale || saleIsShallow

  return (
    <Suspense
      fallback={
        <div className={sectionHeaderDefaultClasses}>
          <div className="p-2">Loading Sale Details...</div>
        </div>
      }
    >
      {!fetch && <SaleWithoutFetch {...props} />}
      {fetch && <SaleWithFetch {...props} saleId={saleId || sale.id} />}
    </Suspense>
  )
}
